import { Base64 } from 'js-base64';

import GlobalEventBus from '@/GlobalEventBus';
import GlobalEvents from '@/GlobalEvents';

let tooltipID = 0;
let timer = null;
const tooltipContentAttr = (args) => {
  const tooltipContent = document.createAttribute('x-tt-content');
  const toEncode = args.value == null || args.value.content == null ? args.value : args.value.content;
  if (toEncode != null) {
    tooltipContent.value = toEncode.replace == null ? null : Base64.encode(toEncode);
  } else {
    tooltipContent.value = '';
  }

  return tooltipContent;
};

export default {
  mounted: (el, args) => {
    // only show tooltip if the content is too long to fit in the element
    if (args.arg === 'clever' && el.offsetWidth === el.scrollWidth) {
      return;
    }

    const tooltipVisibility = document.createAttribute('x-tt-visible');
    tooltipVisibility.value = `${args.value == null || args.value.visible == null ? true : args.value.visible}`;
    el.attributes.setNamedItem(tooltipVisibility);
    el.attributes.setNamedItem(tooltipContentAttr(args));

    const onMouseEnter = (e) => {
      const attrcontent = e.target.getAttribute('x-tt-content');
      if (attrcontent === '') {
        return;
      }
      const content = Base64.decode(e.target.getAttribute('x-tt-content'));
      const isVisible = e.target.getAttribute('x-tt-visible') === 'true';
      let delay = parseInt(`${e.target.getAttribute('x-tt-delay')}`, 10);
      if (Number.isNaN(delay)) {
        delay = 0;
      }
      GlobalEventBus.$emit(GlobalEvents.clearTooltips);
      if (timer != null) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        timer = null;
        if (content != null && isVisible) {
          tooltipID += 1;
          const id = `tooltip-${tooltipID}`;
          const bounds = e.target.getBoundingClientRect();
          const y = bounds.y + bounds.height / 2;
          const x = bounds.x + bounds.width / 2;
          const div = window.document.createElement('div');
          div.id = id;
          div.className = 'hs-tooltip';
          const arrow = window.document.createElement('div');
          arrow.className = 'hs-tooltip-arrow';
          div.append(arrow);
          const inner = window.document.createElement('div');
          inner.className = 'hs-tooltip-inner';
          inner.innerHTML = content;
          div.append(inner);
          div.style.opacity = '0';

          const app = window.document.getElementById('app');
          if (app != null) {
            app.append(div);
          }
          inner.style.maxWidth = '25vw';

          let tooltipBounds = div.getBoundingClientRect();
          inner.style.minWidth = `${tooltipBounds.width}px`;
          tooltipBounds = div.getBoundingClientRect();

          const marginY = e.target.offsetHeight / 2;
          const marginX = e.target.offsetWidth / 2;
          const offsets = {
            top: {
              x: 0,
              y: -marginY,
              transform: 'translate(-50%, -100%)',
            },
            bottom: {
              x: 0,
              y: marginY,
              transform: 'translate(-50%, 100%)',
            },
            left: {
              x: -marginX,
              y: 0,
              transform: 'translate(-100%, -50%)',
            },
            right: {
              x: marginX,
              y: 0,
              transform: 'translateY(-50%)',
            },
          };

          let placement = 'top';

          // Check for collisions with window boundaries.
          let recommendedPlacement = null;
          if (y - bounds.height / 2 - tooltipBounds.height > window.innerHeight) {
            recommendedPlacement = 'top';
          } else if (x + bounds.width / 2 - tooltipBounds.width < 0) {
            recommendedPlacement = 'right';
          } else if (x - bounds.width / 2 + tooltipBounds.width > window.innerWidth) {
            recommendedPlacement = 'left';
          } else if (y + bounds.height / 2 - tooltipBounds.height < 0) {
            recommendedPlacement = 'bottom';
          }

          if (recommendedPlacement != null) {
            placement = recommendedPlacement;
          }

          const placementAttr = document.createAttribute('x-placement');
          placementAttr.value = placement;
          div.attributes.setNamedItem(placementAttr);

          const hiddenAttr = document.createAttribute('aria-hidden');
          hiddenAttr.value = false;
          div.attributes.setNamedItem(hiddenAttr);

          const tooltipIdAttr = document.createAttribute('tooltip-id');
          tooltipIdAttr.value = id;
          e.target.attributes.setNamedItem(tooltipIdAttr);

          div.style.top = `${y + offsets[placement].y}px`;
          div.style.left = `${x + offsets[placement].x}px`;
          div.style.transform = offsets[placement].transform;
          div.style.opacity = 1;
        }
      }, delay);
    };

    const onMouseLeave = (e) => {
      clearTimeout(timer);
      const tooltip = window.document.getElementById(e.target.getAttribute('tooltip-id'));
      if (tooltip == null) {
        return;
      }
      let delay = parseInt(`${e.target.getAttribute('x-tt-delay')}`, 10);
      if (Number.isNaN(delay)) {
        delay = 10000;
      }
      tooltip.setAttribute('aria-hidden', 'true');
      setTimeout(() => {
        tooltip.remove();
      }, 1000 + delay);
    };

    el.addEventListener('mouseenter', onMouseEnter);
    el.addEventListener('mouseleave', onMouseLeave);
  },
  updated: (el, args) => {
    const tooltipVisibility = document.createAttribute('x-tt-visible');
    tooltipVisibility.value = `${args.value == null || args.value.visible == null ? true : args.value.visible}`;
    el.attributes.setNamedItem(tooltipVisibility);

    const tooltipDelay = document.createAttribute('x-tt-delay');
    tooltipDelay.value = `${args.value == null || args.value.delay == null ? true : args.value.delay}`;
    el.attributes.setNamedItem(tooltipDelay);
    el.attributes.setNamedItem(tooltipContentAttr(args));
  },
};
